<template>
<div>
  <div>
    <card>
      <div slot="title">
        <div class="flex" style="justify-content: space-between">
          <h4>续约统计</h4>
          <select-range  @search="search" ref="date" :disabledDate=false></select-range>
        </div>
      </div>
      <Table
        :columns="columns" :data="data" :loading="loading"
      ></Table>
    </card>
  </div>

</div>
</template>

<script>
  import Card from './Card'
  import SelectRange from './SelectRange'
  import {renewStatistics} from "../../../api/homepage";

  export default {
    name: "Renew",
    components:{
      Card,
      SelectRange,
      // TableList
    },
    data(){
      return {
        current:1,
        total:0,
        loading:false,
        data:[],
        columns:[
          {
            title: '租约类型',
            key: 'rentTypeDesc',
            align: 'center',
            width:100
          },
          {title:' '},
          {
            title: '到期合同数',
            key: 'maturities',
            align: 'center',
            width:100,
          },
          {title:' '},
          {
            width:100,
            title: '已续约',
            key: 'renewals',
            align: 'center'
          },
          {title:' '},
          {
            width:100,
            title: '已解约',
            key: 'rescission',
            align: 'center'
          },
          {title:' '},
          {
            width:100,
            title: '续约率',
            key: 'renewRate',
            align: 'center'
          },
          {title:' '},
          {
            width:100,
            title: '剩余需跟进',
            key: 'needToFollowedUp',
            align: 'center'
          },
          {title:' '},
          {
            width:140,
            title: '已跟进-确定续约',
            key: 'confirmRenewalsByFollowedUp',
            align: 'center'
          },
          {title:' '},
          {
            width:140,
            title: '已跟进-确定解约',
            key: 'confirmRescissionByFollowedUp',
            align: 'center'
          },
          {title:' '},
          {
            width:130,
            title: '已跟进-未确定',
            key: 'undeterminedByFollowedUp',
            align: 'center'
          },
          {title:' '},
          {
            width:100,
            title: '未跟进',
            key: 'notFollowedUp',
            align: 'center'
          },

        ],
        searched:null,
      }
    },
    watch:{
      // projectFid(){
      //  this.search(this.$refs['date'].searchParams)
      // },
      projectFids:{
        deep:true,
        handler(){
          this.search(this.$refs['date'].searchParams)
        }
      }

    },
    props:{
      projectFid:{
        type:String,
        default:''
      },
      projectFids:{
        type:Array,
        default(){
          return []
        }
      },

    },
    methods:{
      search(data){
        const params={
          projectFids:this.projectFids,
              ...data,
        }
        this.loading=true
        renewStatistics(params).then(res=>{

          this.data=res.data ||[]

        }).catch(()=>{return}).finally(()=>{
          this.loading=false

        })

      },
    }
  }
</script>

<style scoped>

</style>
